
import { inject, Injectable, Injector } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CityLoginResponse, CityUserInfo } from '../models/login.model';
// import { AppConsts } from '../app-consts';



@Injectable()
export class AppSessionService {
  get userInfo(): CityUserInfo | undefined {
    return this._userInfo;
  }

  set userInfo(value: CityUserInfo | undefined) {
    if (value) {
      localStorage.setItem('userInfo', JSON.stringify(value));
    } else {
      localStorage.removeItem('userInfo');
    }
    this._userInfo = value;
  }


  get expiresAt(): Date | null {
    return this._expiresAt;
  }

  set expiresAt(value: string | null) {
    if (value) {
      localStorage.setItem('expiresAt', value);
      this._expiresAt = new Date(value);
    } else {
      localStorage.removeItem('expiresAt');
      this._expiresAt = null;
    }

  }
  get refreshToken(): string | null {

    return this._refreshToken;
  }

  set refreshToken(value: string | null) {
    if (value) {
      localStorage.setItem('refreshToken', value);
    } else {
      localStorage.removeItem('refreshToken');
    }
    this._refreshToken = value;
  }
  get accessToken(): string | null {
    return this._accessToken;
  }

  set accessToken(value: string | null) {
    if (value) {
      localStorage.setItem('accessToken', value);
    } else {
      localStorage.removeItem('accessToken');
    }

    this._accessToken = value;
  }

  private _accessToken: string | null = null;
  private _refreshToken: string | null = null;
  private _expiresAt: Date | null = null;
  private _userInfo: CityUserInfo | undefined;

  constructor() {
    this.locaDataFromLocalStorage();
  }

  locaDataFromLocalStorage() {
    const userInfo = localStorage.getItem('userInfo');
    if (userInfo) {
      this._userInfo = JSON.parse(userInfo);
    }

    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      this._accessToken = accessToken;
    }

    const refreshToken = localStorage.getItem('refreshToken');
    if (refreshToken) {
      this._refreshToken = refreshToken;
    }

    const expiresAt = localStorage.getItem('expiresAt');
    if (expiresAt) {
      this._expiresAt = new Date(expiresAt);
    }


  }


  setData(data: CityLoginResponse | undefined) {
    if (data) {
      this.accessToken = data.accessToken ?? null;
      this.refreshToken = data.refreshToken ?? null;
      this.expiresAt = data.expiresAt ?? null;
      this.userInfo = data.user ?? undefined;
    } else {
      this.resetInfo();
    }
  }

  resetInfo() {
    this.userInfo = undefined;
    this.accessToken = null;
    this.refreshToken = null;
    this.expiresAt = null;

  }

}
